var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":"/categories"}},[_c('div',{staticClass:"page"},[_c('video',{attrs:{"src":require(`@/assets/video/EAJ_FW26-HALLOWEEN_LAVAGNA.mp4`),"type":"video/mp4","loop":"","autoplay":"","muted":""},domProps:{"muted":true}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }